import React, { useState, useEffect } from 'react';
import AECPLogo from './dashboard/images/AECP_logo.png';
import loginBgImg from './dashboard/images/loginbgimg.jpeg';
import { Button } from 'reactstrap';
import { api } from './api';

const Login = () => {
    const [showLogin, setShowLogin] = useState(false);
    const [loginData, setLoginData] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [showSubscribe, setShowSubscribe] = useState(false);
    const [showTrialExpired, setShowTrialExpired] = useState(false);
    const [expiredCompanyId, setExpiredCompanyId] = useState("");
    const [expiredRole, setExpiredRole] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showTrialPopup, setShowTrialPopup] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [forgotPasswordStep, setForgotPasswordStep] = useState('method'); // method, email, mobile, otp, newPassword
    const [forgotPasswordData, setForgotPasswordData] = useState({
        email: '',
        mobile: '',
        otp: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
    const [forgotPasswordError, setForgotPasswordError] = useState('');
    const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [verificationMethod, setVerificationMethod] = useState('email'); // email or mobile

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowLogin(true);
        }, 45);
        const cookieValue = getCookie('token');
        const cookieValue1 = getCookie('path');
        if (cookieValue && cookieValue1 ) {
            window.location.href = cookieValue1;
        }
        return () => clearTimeout(timeoutId);
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLoginData(prevState => ({ ...prevState, [name]: value }));
        
        // Clear error and success messages when user starts typing
        if (errorMsg || successMsg) {
            setErrorMsg('');
            setSuccessMsg('');
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setErrorMsg('');
        setSuccessMsg('');
        setShowSubscribe(false);
        setShowTrialExpired(false);
        setExpiredCompanyId("");
        setExpiredRole("");
        
        // Validate input based on whether it's email or phone
        let loginDataToSend = { ...loginData };
        
        if (loginData.email.includes('@')) {
            // It's an email (personal or company email)
            loginDataToSend.loginType = 'email';
        } else {
            // It's a phone number, validate it
            const cleanPhone = loginData.email.replace(/\D/g, '');
            if (cleanPhone.length < 10) {
                setErrorMsg('Please enter a valid 10-digit phone number');
                setLoading(false);
                return;
            }
            // Update with cleaned phone number
            loginDataToSend.email = cleanPhone;
            loginDataToSend.loginType = 'phone';
        }
        
        try {
            const response = await api.post("Login.php", loginDataToSend);
            const { status, message, token, company_id, company_name, role, path, emp_id, trial_expired } = response.data;
            if (status === "success") {
                setSuccessMsg('Login successful! Redirecting...');
                if (role !== undefined && role !== null) {
                    document.cookie = `role=${role}; path=/`;
                }
                if (company_id) document.cookie = `company_id=${company_id}; path=/`;
                if (company_name) document.cookie = `company_name=${encodeURIComponent(company_name)}; path=/`;
                if (emp_id) document.cookie = `emp_id=${emp_id}; path=/`;
                document.cookie = `token=${token}; path=/`;
                document.cookie = `path=${path}; path=/`;
                setLoading(false);
                setTimeout(() => {
                    window.location.href = path;
                }, 1000);
            } else if (trial_expired) {
                setExpiredCompanyId(company_id || "");
                setExpiredRole(role || "");
                setShowTrialPopup(true);
                setErrorMsg(message || "Your trial has expired.");
                setLoading(false);
            } else {
                setErrorMsg(message || "Invalid username or password");
                setLoading(false);
            }
        } catch (error) {
            console.error('Login error:', error);
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMsg(error.response.data.message);
            } else if (error.message) {
                setErrorMsg(error.message);
            } else {
                setErrorMsg("Network or server error. Please try again.");
            }
            setLoading(false);
        }
    };

    const getCookie = (name) => {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return '';
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleNewPasswordVisibility = () => {
        setShowNewPassword(!showNewPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleForgotPasswordInputChange = (e) => {
        const { name, value } = e.target;
        setForgotPasswordData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleSendOTP = async () => {
        setForgotPasswordLoading(true);
        setForgotPasswordError('');
        
        try {
            if (verificationMethod === 'email') {
                const response = await api.post("forgotPassword.php", {
                    email: forgotPasswordData.email
                });
                
                if (response.data.status === "success") {
                    setForgotPasswordStep('otp');
                    setForgotPasswordSuccess('OTP sent to your email successfully!');
                } else {
                    setForgotPasswordError(response.data.message || 'Email not found in our records.');
                }
            } else {
                // Mobile OTP
                const company_id = getCookie('company_id');
                const response = await api.post("sendMobileOTP.php", {
                    mobile: forgotPasswordData.mobile,
                    company_id: company_id
                });
                
                if (response.data.status === "success") {
                    setForgotPasswordStep('otp');
                    setForgotPasswordSuccess(response.data.message);
                } else if (response.data.suggest_email) {
                    setForgotPasswordError(response.data.message);
                    setVerificationMethod('email');
                    setForgotPasswordStep('email');
                } else {
                    setForgotPasswordError(response.data.message || 'Failed to send OTP.');
                }
            }
        } catch (error) {
            setForgotPasswordError('Network error. Please try again.');
        } finally {
            setForgotPasswordLoading(false);
        }
    };

    const handleVerifyOTP = async () => {
        setForgotPasswordLoading(true);
        setForgotPasswordError('');
        
        try {
            if (verificationMethod === 'email') {
                const response = await api.post("verifyOTP.php", {
                    email: forgotPasswordData.email,
                    otp: forgotPasswordData.otp
                });
                
                if (response.data.status === "success") {
                    setForgotPasswordStep('newPassword');
                    setForgotPasswordSuccess('OTP verified successfully!');
                } else {
                    setForgotPasswordError(response.data.message || 'Invalid OTP.');
                }
            } else {
                // Mobile OTP verification
                const response = await api.post("verifyMobileOTP.php", {
                    mobile: forgotPasswordData.mobile,
                    otp: forgotPasswordData.otp
                });
                
                if (response.data.status === "success") {
                    setForgotPasswordStep('newPassword');
                    setForgotPasswordSuccess('OTP verified successfully!');
                } else if (response.data.suggest_email) {
                    setForgotPasswordError(response.data.message);
                    setVerificationMethod('email');
                    setForgotPasswordStep('email');
                } else {
                    setForgotPasswordError(response.data.message || 'Invalid OTP.');
                }
            }
        } catch (error) {
            setForgotPasswordError('Network error. Please try again.');
        } finally {
            setForgotPasswordLoading(false);
        }
    };

    const handleResetPassword = async () => {
        if (forgotPasswordData.newPassword !== forgotPasswordData.confirmPassword) {
            setForgotPasswordError('Passwords do not match.');
            return;
        }
        
        if (forgotPasswordData.newPassword.length < 6) {
            setForgotPasswordError('Password must be at least 6 characters long.');
            return;
        }
        
        setForgotPasswordLoading(true);
        setForgotPasswordError('');
        
        try {
            if (verificationMethod === 'email') {
                const response = await api.post("resetPassword.php", {
                    email: forgotPasswordData.email,
                    newPassword: forgotPasswordData.newPassword
                });
                
                if (response.data.status === "success") {
                    setForgotPasswordSuccess('Password updated successfully! You can now login with your new password.');
                    setTimeout(() => {
                        setShowForgotPassword(false);
                        setForgotPasswordStep('method');
                        setForgotPasswordData({
                            email: '',
                            mobile: '',
                            otp: '',
                            newPassword: '',
                            confirmPassword: ''
                        });
                        setForgotPasswordError('');
                        setForgotPasswordSuccess('');
                        setVerificationMethod('email');
                    }, 2000);
                } else {
                    setForgotPasswordError(response.data.message || 'Failed to update password.');
                }
            } else {
                // Mobile password reset
                const response = await api.post("resetPasswordMobile.php", {
                    mobile: forgotPasswordData.mobile,
                    newPassword: forgotPasswordData.newPassword
                });
                
                if (response.data.status === "success") {
                    setForgotPasswordSuccess('Password updated successfully! You can now login with your new password.');
                    setTimeout(() => {
                        setShowForgotPassword(false);
                        setForgotPasswordStep('method');
                        setForgotPasswordData({
                            email: '',
                            mobile: '',
                            otp: '',
                            newPassword: '',
                            confirmPassword: ''
                        });
                        setForgotPasswordError('');
                        setForgotPasswordSuccess('');
                        setVerificationMethod('email');
                    }, 2000);
                } else {
                    setForgotPasswordError(response.data.message || 'Failed to update password.');
                }
            }
        } catch (error) {
            setForgotPasswordError('Network error. Please try again.');
        } finally {
            setForgotPasswordLoading(false);
        }
    };

    const closeForgotPassword = () => {
        setShowForgotPassword(false);
        setForgotPasswordStep('method');
        setForgotPasswordData({
            email: '',
            mobile: '',
            otp: '',
            newPassword: '',
            confirmPassword: ''
        });
        setForgotPasswordError('');
        setForgotPasswordSuccess('');
        setVerificationMethod('email');
    };

    return (
        <>
            <style>
                {`
                    @keyframes fadeInUp {
                        from {
                            opacity: 0;
                            transform: translateY(30px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                    
                    @keyframes float {
                        0%, 100% { transform: translateY(0px); }
                        50% { transform: translateY(-10px); }
                    }
                    
                    @keyframes slideInDown {
                        from {
                            opacity: 0;
                            transform: translateY(-20px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                    
                    .glass-input:focus {
                        border-color: rgba(224,134,129,0.8) !important;
                        box-shadow: 0 8px 25px rgba(224,134,129,0.2) !important;
                        transform: translateY(-2px);
                    }
                    
                    .glass-button:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 12px 35px rgba(224,134,129,0.4) !important;
                    }
                    
                    .glass-button:active {
                        transform: translateY(0);
                    }
                `}
            </style>
        <div style={{
            minHeight: '100vh',
            width: '100vw',
            background: `url(${loginBgImg}) center center / cover no-repeat`,
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(255,255,255,0.02)',
                backdropFilter: 'blur(1px)',
                zIndex: 1
            }} />
            {showLogin && (
                <div style={{
                    position: 'relative',
                    zIndex: 2,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <div style={{
                        background: 'rgba(255,255,255,0.15)',
                        borderRadius: 24,
                        boxShadow: '0 25px 45px rgba(0,0,0,0.1), 0 0 0 1px rgba(255,255,255,0.2)',
                        padding: '32px 50px 32px 50px',
                        maxWidth: 520,
                        width: '100%',
                        margin: 16,
                        position: 'relative',
                        zIndex: 3,
                        backdropFilter: 'blur(25px)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        animation: 'fadeInUp 0.8s ease-out',
                    }}>
                        <div style={{ textAlign: 'center', marginBottom: 20 }}>
                            <img src={AECPLogo} alt="AECP Logo" style={{ 
                                width: 140, 
                                marginBottom: 12,
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }} />
                            <h2 style={{ color: '#000000', fontWeight: 700, marginBottom: 2, fontSize: '28px' }}>Welcome Back</h2>
                            <div style={{ color: '#000000', fontWeight: 400, fontSize: 16, marginBottom: 0 }}>Please login to continue</div>
                        </div>
                        {errorMsg && (
                            <div style={{
                                background: '#f8d7da',
                                color: '#721c24',
                                padding: '12px 16px',
                                borderRadius: '8px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                border: '1px solid #f5c6cb',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                animation: 'slideInDown 0.3s ease-out'
                            }}>
                                <i className="fas fa-exclamation-circle" style={{ fontSize: '16px' }}></i>
                                {errorMsg}
                            </div>
                        )}
                        {successMsg && (
                            <div style={{
                                background: '#d4edda',
                                color: '#155724',
                                padding: '12px 16px',
                                borderRadius: '8px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                border: '1px solid #c3e6cb',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                animation: 'slideInDown 0.3s ease-out'
                            }}>
                                <i className="fas fa-check-circle" style={{ fontSize: '16px' }}></i>
                                {successMsg}
                            </div>
                        )}
                        <form onSubmit={handleSubmit} autoComplete="off" style={{ maxWidth: '380px', margin: '0 auto' }}>
                             <div style={{ marginBottom: 20 }}>
                                 <label style={{ 
                                     display: 'block', 
                                     color: '#000000', 
                                     fontWeight: 500, 
                                     fontSize: 14, 
                                     marginBottom: 6 
                                 }}>
                                     Email or Phone Number
                                 </label>
                                 <div style={{ position: 'relative' }}>
                                     <i className="fas fa-user" style={{
                                         position: 'absolute',
                                         top: '50%',
                                         left: 12,
                                         transform: 'translateY(-50%)',
                                         color: '#000000',
                                         fontSize: 16,
                                         zIndex: 2,
                                     }}></i>
                                     <input
                                         type="text"
                                         name='email'
                                         required
                                         placeholder='Enter your email or phone number'
                                         value={loginData.email}
                                         onChange={handleInputChange}
                                         style={{
                                             width: '100%',
                                             border: '1px solid rgba(224,134,129,0.4)',
                                             borderRadius: 12,
                                             padding: '14px 40px 14px 38px',
                                             fontSize: 16,
                                             outline: 'none',
                                             color: '#000000',
                                             background: 'rgba(255,255,255,0.3)',
                                             fontWeight: 400,
                                             transition: 'all 0.3s ease',
                                             backdropFilter: 'blur(10px)',
                                             boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                         }}
                                         disabled={loading}
                                     />
                                 </div>
                             </div>
                             <div style={{ marginBottom: 20 }}>
                                <label style={{ 
                                    display: 'block', 
                                    color: '#000000', 
                                    fontWeight: 500, 
                                    fontSize: 14, 
                                    marginBottom: 6 
                                }}>
                                    Password
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <i className="fas fa-lock" style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: 12,
                                        transform: 'translateY(-50%)',
                                        color: '#000000',
                                        fontSize: 16,
                                        zIndex: 2,
                                    }}></i>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        name='password'
                                        placeholder='Enter your password'
                                        required
                                        value={loginData.password}
                                        onChange={handleInputChange}
                                        style={{
                                            width: '100%',
                                            border: '1px solid rgba(224,134,129,0.4)',
                                            borderRadius: 12,
                                            padding: '14px 40px 14px 38px',
                                            fontSize: 16,
                                            outline: 'none',
                                            color: '#000000',
                                            background: 'rgba(255,255,255,0.3)',
                                            fontWeight: 400,
                                            transition: 'all 0.3s ease',
                                            backdropFilter: 'blur(10px)',
                                            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                        }}
                                        disabled={loading}
                                    />
                                    <i
                                        className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                        onClick={togglePasswordVisibility}
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            right: 12,
                                            transform: 'translateY(-50%)',
                                            color: '#000000',
                                            fontSize: 16,
                                            cursor: 'pointer',
                                            zIndex: 2,
                                        }}
                                    ></i>
                                </div>
                            </div>

                            <Button type="submit" style={{
                                width: '100%',
                                background: '#E08681',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 12,
                                padding: '16px 0',
                                fontWeight: 700,
                                fontSize: 18,
                                marginTop: 16,
                                boxShadow: '0 8px 25px rgba(224,134,129,0.3), 0 0 0 1px rgba(255,255,255,0.2)',
                                backdropFilter: 'blur(10px)',
                                transition: 'all 0.3s ease',
                                position: 'relative',
                                overflow: 'hidden',
                            }} disabled={loading}>
                                {loading ? 'Logging in...' : 'Login'}
                            </Button>
                            
                            <div style={{ textAlign: 'center', marginTop: 16 }}>
                                <button
                                    type="button"
                                    onClick={() => setShowForgotPassword(true)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#000000',
                                        fontSize: 14,
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        transition: 'color 0.3s ease',
                                    }}
                                >
                                    Forgot Password?
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
        
        {/* Trial Expired Popup Modal */}
        {showTrialPopup && (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                backdropFilter: 'blur(5px)',
            }}>
                <div style={{
                    background: 'rgba(255,255,255,0.95)',
                    borderRadius: 16,
                    padding: '32px',
                    maxWidth: '400px',
                    width: '90%',
                    textAlign: 'center',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    backdropFilter: 'blur(20px)',
                }}>
                    <h3 style={{
                        color: '#000000',
                        fontSize: '20px',
                        fontWeight: 600,
                        marginBottom: '16px',
                    }}>
                        Trial Expired
                    </h3>
                    <p style={{
                        color: '#000000',
                        fontSize: '16px',
                        lineHeight: '1.5',
                        marginBottom: '24px',
                    }}>
                        {errorMsg}
                    </p>
                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'center',
                    }}>
                        <button
                            onClick={() => setShowTrialPopup(false)}
                            style={{
                                background: '#6c757d',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 8,
                                padding: '12px 24px',
                                fontWeight: 500,
                                fontSize: '14px',
                                cursor: 'pointer',
                                transition: 'background 0.2s',
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        )}

        {/* Forgot Password Modal */}
        {showForgotPassword && (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                backdropFilter: 'blur(5px)',
            }}>
                <div style={{
                    background: 'rgba(255,255,255,0.95)',
                    borderRadius: 16,
                    padding: '32px',
                    maxWidth: '400px',
                    width: '90%',
                    textAlign: 'center',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    backdropFilter: 'blur(20px)',
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '24px',
                    }}>
                        <h3 style={{
                            color: '#000000',
                            fontSize: '20px',
                            fontWeight: 600,
                            margin: 0,
                        }}>
                            {forgotPasswordStep === 'email' ? 'Forgot Password' : 
                             forgotPasswordStep === 'otp' ? 'Enter OTP' : 'Reset Password'}
                        </h3>
                        <button
                            onClick={closeForgotPassword}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '24px',
                                cursor: 'pointer',
                                color: '#666',
                            }}
                        >
                            ×
                        </button>
                    </div>

                    {forgotPasswordError && (
                        <div style={{
                            background: '#f8d7da',
                            color: '#721c24',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '16px',
                            fontSize: '14px',
                        }}>
                            {forgotPasswordError}
                        </div>
                    )}

                    {forgotPasswordSuccess && (
                        <div style={{
                            background: '#d4edda',
                            color: '#155724',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '16px',
                            fontSize: '14px',
                        }}>
                            {forgotPasswordSuccess}
                        </div>
                    )}

                    {forgotPasswordStep === 'method' && (
                        <div>
                            <p style={{
                                color: '#666',
                                fontSize: '14px',
                                marginBottom: '20px',
                                lineHeight: '1.5',
                            }}>
                                Choose how you'd like to reset your password:
                            </p>
                            <div style={{ marginBottom: '20px' }}>
                                <div style={{
                                    display: 'flex',
                                    gap: '12px',
                                    marginBottom: '16px'
                                }}>
                                    <label style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        cursor: 'pointer'
                                    }}>
                                        <input
                                            type="radio"
                                            name="verificationMethod"
                                            value="email"
                                            checked={verificationMethod === 'email'}
                                            onChange={(e) => setVerificationMethod(e.target.value)}
                                            style={{ margin: 0 }}
                                        />
                                        <span>Email OTP</span>
                                    </label>
                                    <label style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        cursor: 'pointer'
                                    }}>
                                        <input
                                            type="radio"
                                            name="verificationMethod"
                                            value="mobile"
                                            checked={verificationMethod === 'mobile'}
                                            onChange={(e) => setVerificationMethod(e.target.value)}
                                            style={{ margin: 0 }}
                                        />
                                        <span>Mobile OTP</span>
                                    </label>
                                </div>
                            </div>
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                justifyContent: 'center',
                            }}>
                                <button
                                    onClick={() => setForgotPasswordStep(verificationMethod)}
                                    style={{
                                        background: '#E08681',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: '500',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Continue
                                </button>
                            </div>
                        </div>
                    )}

                    {forgotPasswordStep === 'email' && (
                        <div>
                            <p style={{
                                color: '#666',
                                fontSize: '14px',
                                marginBottom: '20px',
                                lineHeight: '1.5',
                            }}>
                                Enter your email address to receive a password reset OTP.
                            </p>
                            <div style={{ marginBottom: '20px' }}>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Enter your email"
                                    value={forgotPasswordData.email}
                                    onChange={handleForgotPasswordInputChange}
                                    style={{
                                        width: '100%',
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        padding: '12px',
                                        fontSize: '14px',
                                        outline: 'none',
                                    }}
                                    disabled={forgotPasswordLoading}
                                />
                            </div>
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                justifyContent: 'center',
                            }}>
                                <button
                                    onClick={() => setForgotPasswordStep('method')}
                                    style={{
                                        background: '#6c757d',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: '500',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Back
                                </button>
                                <button
                                    onClick={handleSendOTP}
                                    disabled={forgotPasswordLoading}
                                    style={{
                                        background: '#E08681',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        opacity: forgotPasswordLoading ? 0.7 : 1,
                                    }}
                                >
                                    {forgotPasswordLoading ? 'Sending...' : 'Send OTP'}
                                </button>
                            </div>
                        </div>
                    )}

                    {forgotPasswordStep === 'mobile' && (
                        <div>
                            <p style={{
                                color: '#666',
                                fontSize: '14px',
                                marginBottom: '20px',
                                lineHeight: '1.5',
                            }}>
                                Enter your mobile number to receive an OTP via SMS.
                            </p>
                            <div style={{ marginBottom: '20px' }}>
                                <input
                                    type="tel"
                                    name="mobile"
                                    placeholder="Enter your 10-digit mobile number"
                                    value={forgotPasswordData.mobile}
                                    onChange={handleForgotPasswordInputChange}
                                    style={{
                                        width: '100%',
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        padding: '12px',
                                        fontSize: '14px',
                                        outline: 'none',
                                    }}
                                    disabled={forgotPasswordLoading}
                                />
                            </div>
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                justifyContent: 'center',
                            }}>
                                <button
                                    onClick={() => setForgotPasswordStep('method')}
                                    style={{
                                        background: '#6c757d',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: '500',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Back
                                </button>
                                <button
                                    onClick={handleSendOTP}
                                    disabled={forgotPasswordLoading}
                                    style={{
                                        background: '#E08681',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: '500',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        opacity: forgotPasswordLoading ? 0.7 : 1,
                                    }}
                                >
                                    {forgotPasswordLoading ? 'Sending...' : 'Send OTP'}
                                </button>
                            </div>
                        </div>
                    )}

                    {forgotPasswordStep === 'otp' && (
                        <div>
                            <p style={{
                                color: '#666',
                                fontSize: '14px',
                                marginBottom: '20px',
                                lineHeight: '1.5',
                            }}>
                                Enter the OTP sent to your {verificationMethod === 'email' ? 'email' : 'mobile'}.
                            </p>
                            <div style={{ marginBottom: '20px' }}>
                                <input
                                    type="text"
                                    name="otp"
                                    placeholder="Enter OTP"
                                    value={forgotPasswordData.otp}
                                    onChange={handleForgotPasswordInputChange}
                                    style={{
                                        width: '100%',
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        padding: '12px',
                                        fontSize: '14px',
                                        outline: 'none',
                                    }}
                                    disabled={forgotPasswordLoading}
                                />
                            </div>
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                justifyContent: 'center',
                            }}>
                                <button
                                    onClick={() => setForgotPasswordStep(verificationMethod)}
                                    style={{
                                        background: '#6c757d',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Back
                                </button>
                                <button
                                    onClick={handleVerifyOTP}
                                    disabled={forgotPasswordLoading}
                                    style={{
                                        background: '#E08681',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        opacity: forgotPasswordLoading ? 0.7 : 1,
                                    }}
                                >
                                    {forgotPasswordLoading ? 'Verifying...' : 'Verify OTP'}
                                </button>
                            </div>
                        </div>
                    )}

                    {forgotPasswordStep === 'newPassword' && (
                        <div>
                            <p style={{
                                color: '#666',
                                fontSize: '14px',
                                marginBottom: '20px',
                                lineHeight: '1.5',
                            }}>
                                Enter your new password.
                            </p>
                            <div style={{ marginBottom: '16px' }}>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type={showNewPassword ? 'text' : 'password'}
                                        name="newPassword"
                                        placeholder="New Password"
                                        value={forgotPasswordData.newPassword}
                                        onChange={handleForgotPasswordInputChange}
                                        style={{
                                            width: '100%',
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            padding: '12px 40px 12px 12px',
                                            fontSize: '14px',
                                            outline: 'none',
                                        }}
                                        disabled={forgotPasswordLoading}
                                    />
                                    <i
                                        className={`fas ${showNewPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                        onClick={toggleNewPasswordVisibility}
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            right: 12,
                                            transform: 'translateY(-50%)',
                                            color: '#666',
                                            fontSize: 16,
                                            cursor: 'pointer',
                                            zIndex: 2,
                                        }}
                                    ></i>
                                </div>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        name="confirmPassword"
                                        placeholder="Confirm New Password"
                                        value={forgotPasswordData.confirmPassword}
                                        onChange={handleForgotPasswordInputChange}
                                        style={{
                                            width: '100%',
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            padding: '12px 40px 12px 12px',
                                            fontSize: '14px',
                                            outline: 'none',
                                        }}
                                        disabled={forgotPasswordLoading}
                                    />
                                    <i
                                        className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                        onClick={toggleConfirmPasswordVisibility}
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            right: 12,
                                            transform: 'translateY(-50%)',
                                            color: '#666',
                                            fontSize: 16,
                                            cursor: 'pointer',
                                            zIndex: 2,
                                        }}
                                    ></i>
                                </div>
                            </div>
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                justifyContent: 'center',
                            }}>
                                <button
                                    onClick={() => setForgotPasswordStep('otp')}
                                    style={{
                                        background: '#6c757d',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Back
                                </button>
                                <button
                                    onClick={handleResetPassword}
                                    disabled={forgotPasswordLoading}
                                    style={{
                                        background: '#E08681',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        opacity: forgotPasswordLoading ? 0.7 : 1,
                                    }}
                                >
                                    {forgotPasswordLoading ? 'Updating...' : 'Update Password'}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )}
        </>
    );
};

export default Login;